import { render, staticRenderFns } from "./selectCompay.vue?vue&type=template&id=2b40545a&scoped=true"
import script from "./selectCompay.vue?vue&type=script&lang=js"
export * from "./selectCompay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40545a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b40545a')) {
      api.createRecord('2b40545a', component.options)
    } else {
      api.reload('2b40545a', component.options)
    }
    module.hot.accept("./selectCompay.vue?vue&type=template&id=2b40545a&scoped=true", function () {
      api.rerender('2b40545a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplier/coupons/selectCompay.vue"
export default component.exports